import { Form, Input } from 'antd-v5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SettingsContent } from '../../../components/SettingsContent';
import DescriptionBox from '../../../../../../components/Layout/DescriptionBox';

export const SalesPipelineSettings = ({ form }) => {
  return (
    <SettingsContent title="SALES PIPELINE" icon={<FontAwesomeIcon icon={['fas', 'code-branch']} />} className="w-100-P">
      <DescriptionBox
        className="w-100-P"
        title="Sales Pipeline Description"
        description='What name do you want to give the "Sales Opportunity" section on the client profile?'
        input={
          <Form.Item name="salesOppName">
            <Input
              id="InAppDescriptionInput"
              placeholder="Special Order"
              style={{ minWidth: '200px' }}
            />
          </Form.Item>
        }
      />
    </SettingsContent>
  );
};
